module.exports = __webpack_public_path__ + "static/media/planeta7.febff77b.png";